function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Rect, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 330 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement(G, {
    transform: "matrix(0.916496,0,0,0.916496,6.63143,5.49931)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M32.999,14.18C32.114,12.667 30.492,11.737 28.739,11.737C26.986,11.737 25.365,12.667 24.479,14.18L5.082,47.318C4.189,48.845 4.18,50.733 5.06,52.267C5.94,53.802 7.573,54.748 9.342,54.748L48.136,54.748C49.905,54.748 51.538,53.802 52.418,52.267C53.298,50.733 53.29,48.845 52.396,47.318L32.999,14.18Z",
    style: {
      fill: "url(#_Linear1)"
    }
  })), /*#__PURE__*/React.createElement(G, {
    transform: "matrix(1.92895e-17,0.315021,-0.315021,1.92895e-17,45.1188,32.6138)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M36.574,12.087C34.945,9.305 31.963,7.595 28.739,7.595C25.515,7.595 22.533,9.305 20.905,12.087L1.508,45.226C-0.135,48.034 -0.151,51.505 1.467,54.327C3.085,57.149 6.089,58.89 9.342,58.89L48.136,58.89C51.389,58.89 54.393,57.149 56.011,54.327C57.629,51.505 57.614,48.034 55.971,45.226L36.574,12.087Z",
    style: {
      fill: "rgb(248,202,210)"
    }
  })), /*#__PURE__*/React.createElement(G, {
    transform: "matrix(1,0,0,1,120.698,22.2411)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement(G, {
    transform: "matrix(75,0,0,75,-63.5538,32.5887)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M0.556,-0L0.556,-0.483L0.376,-0.483L0.376,-0.185C0.361,-0.168 0.34,-0.147 0.3,-0.147C0.256,-0.147 0.23,-0.166 0.23,-0.215L0.23,-0.483L0.05,-0.483L0.05,-0.138C0.05,-0.055 0.098,0.012 0.21,0.012C0.295,0.012 0.348,-0.023 0.376,-0.054L0.376,-0L0.556,-0Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement(G, {
    transform: "matrix(75,0,0,75,-18.1038,32.5887)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M0.23,-0L0.23,-0.296C0.25,-0.32 0.299,-0.33 0.337,-0.33C0.354,-0.33 0.369,-0.328 0.378,-0.325L0.378,-0.497C0.323,-0.497 0.26,-0.465 0.23,-0.43L0.23,-0.483L0.05,-0.483L0.05,-0L0.23,-0Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement(G, {
    transform: "matrix(75,0,0,75,11.1462,32.5887)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M0.509,-0L0.509,-0.292C0.509,-0.453 0.392,-0.495 0.272,-0.495C0.199,-0.495 0.109,-0.474 0.044,-0.422L0.105,-0.311C0.143,-0.34 0.194,-0.358 0.239,-0.358C0.298,-0.358 0.329,-0.332 0.329,-0.298L0.329,-0.248C0.303,-0.281 0.246,-0.301 0.183,-0.301C0.111,-0.301 0.017,-0.267 0.017,-0.147C0.017,-0.037 0.111,0.012 0.183,0.012C0.243,0.012 0.302,-0.012 0.329,-0.046L0.329,-0L0.509,-0ZM0.258,-0.105C0.228,-0.105 0.195,-0.114 0.195,-0.144C0.195,-0.174 0.228,-0.184 0.258,-0.184C0.286,-0.184 0.317,-0.175 0.329,-0.158L0.329,-0.131C0.317,-0.114 0.286,-0.105 0.258,-0.105Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement(G, {
    transform: "matrix(75,0,0,75,53.0712,32.5887)"
  }, /*#__PURE__*/React.createElement(Rect, {
    x: 0.05,
    y: -0.667,
    width: 0.18,
    height: 0.667,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement(G, {
    transform: "matrix(75,0,0,75,74.0712,32.5887)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M0.288,0.012C0.46,0.012 0.56,-0.107 0.56,-0.242C0.56,-0.377 0.46,-0.495 0.288,-0.495C0.117,-0.495 0.017,-0.377 0.017,-0.242C0.017,-0.107 0.117,0.012 0.288,0.012ZM0.288,-0.147C0.233,-0.147 0.202,-0.188 0.202,-0.242C0.202,-0.295 0.233,-0.336 0.288,-0.336C0.344,-0.336 0.375,-0.295 0.375,-0.242C0.375,-0.188 0.344,-0.147 0.288,-0.147Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement(G, {
    transform: "matrix(75,0,0,75,117.346,32.5887)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M0.556,-0L0.556,-0.483L0.376,-0.483L0.376,-0.185C0.361,-0.168 0.34,-0.147 0.3,-0.147C0.256,-0.147 0.23,-0.166 0.23,-0.215L0.23,-0.483L0.05,-0.483L0.05,-0.138C0.05,-0.055 0.098,0.012 0.21,0.012C0.295,0.012 0.348,-0.023 0.376,-0.054L0.376,-0L0.556,-0Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement(G, {
    transform: "matrix(75,0,0,75,162.796,32.5887)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M0.246,0.012C0.389,0.012 0.475,-0.058 0.475,-0.154C0.475,-0.355 0.201,-0.305 0.201,-0.345C0.201,-0.356 0.22,-0.366 0.246,-0.366C0.302,-0.366 0.358,-0.341 0.388,-0.316L0.454,-0.433C0.398,-0.47 0.326,-0.495 0.245,-0.495C0.105,-0.495 0.029,-0.417 0.029,-0.33C0.029,-0.13 0.303,-0.189 0.303,-0.143C0.303,-0.131 0.292,-0.122 0.255,-0.122C0.201,-0.122 0.119,-0.153 0.081,-0.183L0.009,-0.062C0.061,-0.019 0.157,0.012 0.246,0.012Z",
    style: {
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(38.7938,0,0,33.1387,9.34228,33.2425)"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    style: {
      stopColor: "rgb(209,41,72)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.5,
    style: {
      stopColor: "rgb(232,44,78)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.75,
    style: {
      stopColor: "rgb(243,45,81)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.88,
    style: {
      stopColor: "rgb(249,45,83)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    style: {
      stopColor: "rgb(255,46,84)",
      stopOpacity: 1
    }
  }))));
};
export default SvgLogo;